export default {"src":"/_next/static/media/calendar-multicoloured.a3c65d5a.svg","height":55,"width":55,"blurWidth":0,"blurHeight":0};